import type { LangEnum } from '@/constants/locales'
import { validateRouteNumericParams } from '@/utils/middlewareHelpers'

export default defineNuxtRouteMiddleware(to => {
  const nuxtApp = useNuxtApp()
  const query = to.query
  const locale = nuxtApp.$i18n.locale.value
  const localePath = useLocalePath()

  const validationResult = validateRouteNumericParams(to)

  if (validationResult.shouldAbort) {
    return abortNavigation()
  }
  if (validationResult.shouldRedirect) {
    return navigateTo({ name: to.name, params: validationResult.params, query: to.query, hash: to.hash })
  }

  const pathWithoutLang = getPathWithoutLang(to.path, locale as LangEnum)

  // paths below are for deep link
  if (pathWithoutLang === '/tab/home') {
    const { region_id, ...restQuery } = query
    if (region_id) {
      return navigateTo(localePath({ name: 'regions-rid', params: { rid: region_id }, query: restQuery }), {
        redirectCode: 301,
      })
    }
    return navigateTo(localePath({ name: 'index', query }), { redirectCode: 301 })
  }
  if (pathWithoutLang === '/favorites_list') {
    return navigateTo(localePath({ name: 'index', query }), { redirectCode: 301 })
  }
  if (pathWithoutLang === '/tab/booking') {
    return navigateTo(localePath({ name: 'member-orders', query }), { redirectCode: 301 })
  }
  // paths above are for deep link
})
